module.exports = __webpack_public_path__ + "img/pimmortalcamp_ua.bb19d568.webp";